import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-paperless-electronic-communications-disclosure',
  imports: [BaseModalComponent, MatCheckboxModule, MatIconModule, TranslocoDirective],
  templateUrl: './paperless-electronic-communications-disclosure.component.html',
  styleUrl: './paperless-electronic-communications-disclosure.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaperlessElectronicCommunicationsDisclosureComponent {
  readonly isLoading = input(false);

  protected readonly isChecked = signal(false);

  readonly submit = output<void>();

  readonly cancel = output<void>();

  protected onCheckboxChange(): void {
    this.isChecked.update((v) => !v);
  }

  protected onSubmit(): void {
    if (this.isChecked() && !this.isLoading()) {
      this.submit.emit();
    }
  }

  protected onCancel(): void {
    if (!this.isLoading()) {
      this.cancel.emit();
    }
  }
}
